import { costForecastingService } from '../../services';

export const config: any = {
  getHigestConsumedResources: (params: any) =>
    costForecastingService.getHighestConsumedResources(params),
};
